import { FC, useCallback } from "react";
import { Typography } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../../../store/hooks";
import { currentAccountIdSelector } from "../../../../../../store/account/selectors/current-account/currentAccountIdSelector";
import {
  useDeleteUsersMeOrganisationsCurrentFilterSetsByFilterSetIdMutation,
  useGetUsersMeAccountsByAccountIdFilterSetsV2Query,
} from "../../../../../../services/cloudchipr.api";
import { getCurrentAccountFilterTemplatesThunk } from "../../../../../../store/filters/thunks/filter-set/getCurrentAccountFilterTemplatesThunk";
import { DeleteConfirmationDialog } from "../../../../../common/modals/DeleteConfirmationDialog";

interface DeleteFilterTemplateDialogProps {
  filterSetId: string;
  onClose(): void;
  name: string;
}

export const DeleteFilterTemplateDialog: FC<
  DeleteFilterTemplateDialogProps
> = ({ filterSetId, onClose, name }) => {
  const dispatch = useAppDispatch();
  const currentAccountId = useAppSelector(currentAccountIdSelector);
  const { isFetching } = useGetUsersMeAccountsByAccountIdFilterSetsV2Query(
    { accountId: currentAccountId || "" },
    { skip: !currentAccountId },
  );

  const [trigger, { isLoading }] =
    useDeleteUsersMeOrganisationsCurrentFilterSetsByFilterSetIdMutation();

  const deleteHandler = useCallback(async () => {
    await trigger({ filterSetId });
    await dispatch(getCurrentAccountFilterTemplatesThunk());
    onClose();
  }, [trigger, dispatch, onClose, filterSetId]);

  return (
    <DeleteConfirmationDialog
      open
      onClose={onClose}
      onDelete={deleteHandler}
      loading={isLoading || isFetching}
      title="Delete Filter Template?"
      content={
        <Typography>
          Please confirm if you want to delete
          <Typography component="span" fontWeight="bold">
            {" "}
            {name}{" "}
          </Typography>
          Filter Template.
        </Typography>
      }
    />
  );
};
